module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Device-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('device-info-boxes', {
    attrs: {
      "total": _vm.total
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "device-search",
    attrs: {
      "placeholder": _vm.searchBarPlaceholder,
      "clearable": "",
      "type": "text",
      "disabled": _vm.isSearchBarDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.deviceSearch(_vm.searchQuery)
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }, [_c('el-select', {
    staticClass: "device-filter",
    attrs: {
      "slot": "prepend",
      "data-qa": "Device-Filter-Options",
      "placeholder": "Filter"
    },
    on: {
      "change": _vm.onSelectionChanged
    },
    slot: "prepend",
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, _vm._l((_vm.filterOptions), function(op) {
    return _c('el-option', {
      key: op.key,
      attrs: {
        "label": op.label,
        "value": op.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.deviceSearch(_vm.searchQuery)
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "deviceListTable",
    staticClass: "device-table",
    attrs: {
      "data": _vm.deviceList,
      "element-loading-text": _vm.$t('deviceTableLoadingText'),
      "expand-row-keys": _vm.expanded,
      "row-key": _vm.getRowKey,
      "data-qa": "Content-Device-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "max-height": "100%",
      "row-class-name": "pointer",
      "show-header": ""
    },
    on: {
      "expand-change": _vm.handleExpand,
      "row-click": _vm.toggleRowExpansion,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    staticClass: "empty",
    attrs: {
      "slot": "empty",
      "min-width": "5"
    },
    slot: "empty"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('deviceTableEmptyMessageTitle')) + "\n      "), _c('i18n', {
    attrs: {
      "path": "deviceTableEmptyMessageBody",
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "place": "support",
      "href": "mailto:support@exosite.com"
    }
  }, [_vm._v("support@exosite.com")])])], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('device-info', {
          attrs: {
            "fields": props.row.fields,
            "guests": props.row.guest_emails,
            "identity": props.row.identity,
            "owner": props.row.owner_email
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "identity",
      "label": _vm.$t('deviceTableColSNLabel'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "model",
      "label": _vm.$t('deviceTableColModelLabel'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getDeviceModel(scope.row.model)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "connectedTag",
      "label": _vm.$t('deviceTableColConnectivityStatusLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.getConnectedStatus(scope.row.connectedTag) !== '--') ? _c('i', {
          class: _vm.getConnectedStatusIcon(scope.row.connectedTag)
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getConnectedStatus(scope.row.connectedTag)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "provisioned_time",
      "label": _vm.$t('deviceTableColProvisionedDateLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.convertSecTime(scope.row.provisioned_time),
            "placement": "top-start"
          }
        }, [_c('span', {
          staticClass: "device-provisioned-date"
        }, [_vm._v(_vm._s(_vm.convertSecTime(scope.row.provisioned_time)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "last_seen",
      "label": _vm.$t('deviceTableColLastSeenLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.convertUsTime(scope.row.last_seen),
            "placement": "top-start"
          }
        }, [_c('span', {
          staticClass: "device-last-seen"
        }, [_vm._v(_vm._s(_vm.convertUsTime(scope.row.last_seen)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firmware_version",
      "label": _vm.$t('deviceTableColFirmwareVerLabel'),
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.locked) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('deviceTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-LockDevice-Button-' + scope.row.identity,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmLock(scope.row.identity, scope.row.sn)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.showPagination) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pagination.currentPage,
      "disabled": _vm.isLoading,
      "layout": _vm.pagination.layout,
      "page-size": _vm.pagination.limit,
      "total": _vm.searchedTotal,
      "background": ""
    },
    on: {
      "update:currentPage": function($event) {
        _vm.$set(_vm.pagination, "currentPage", $event)
      },
      "current-change": _vm.getCurrentPageDevice
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('device-lock')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f7d554a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Device.vue
// module id = 960
// module chunks = 3